import { useState } from "react";

const AvatarWithPlaceholder = ({ img }) => {
  const [imgSrc, setImgSrc] = useState(img);

  return (
    <img
      src={imgSrc}
      className="rounded-full size-10"
      alt=""
      onError={() => setImgSrc('/placeholder.svg')}
    />
  );
}

export default AvatarWithPlaceholder;